


/**
 * OktaIcon
 * Simplified Okta logo mark as inline SVG.
 */
const SendIcon = ({ size = 12 }) => (
    <svg width={size} height={size}
        viewBox="0 0 13 13" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M0.497719 4.73389L12.0364 0.36679C12.078 0.35087 12.1234 0.347342 12.167 0.356635C12.2105 0.365927 12.2505 0.387641 12.282 0.419155C12.3135 0.450668 12.3352 0.490632 12.3445 0.534219C12.3538 0.577806 12.3503 0.623151 12.3344 0.664777L7.96728 12.2035C7.94991 12.2473 7.91954 12.2847 7.88025 12.3108C7.84096 12.3368 7.79464 12.3502 7.74752 12.3491C7.70039 12.3481 7.65473 12.3326 7.61666 12.3048C7.57859 12.277 7.54995 12.2382 7.53458 12.1936L5.59031 7.4025C5.56765 7.3346 5.5295 7.27291 5.47888 7.22229C5.42827 7.17167 5.36657 7.13353 5.29867 7.11086L0.507526 5.16832C0.462391 5.1533 0.423 5.12471 0.394742 5.08644C0.366485 5.04818 0.350742 5.00212 0.349668 4.95456C0.348595 4.907 0.362243 4.86028 0.388744 4.82078C0.415246 4.78128 0.453307 4.75093 0.497719 4.73389Z" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12.235 0.464844L5.51367 7.18612" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"
            fill="currentColor"
        />
    </svg>

);

export default SendIcon;
